import React from 'react';

import {roundedElements} from 'Services/BaseHelpers';

/**
 * @function Card
 * @param {JSX.Element} children
 * @param {string} className
 * @param bgColour
 * @return {JSX.Element}
 * @constructor
 */
const Card = ({children, className, bgColour = 'bg-white' }) => {
    return (
        <div className={`
            overflow-hidden sm:shadow w-full
            ${className}
            ${bgColour}
            ${roundedElements() ? '' : ''}
        `}>
            {children}
        </div>
    );
}

export default Card;
